import moment from 'moment';
import * as constAction from 'root/actionConstants';

/**
 * Setea un campo o el reducer completo del componente con el default.
 * @param {string} value Nombre del campo a limpiar ("all" para todo el reducer).
 * @returns {Object}
 */
export const clear = value => ({
  type: constAction.VIAJES_CLEAR,
  payload: value,
});

export const get = () => ({
  type: constAction.VIAJES_GET,
  epic: {
    url: 'viajes/getList',
    method: 'GET',
  },
});

export const concatToState = (stateName, data) => ({
  type: constAction.VIAJES_CONCAT_STATE,
  payload: { stateName, data },
});

export const findUpdState = (id, stateName, data) => ({
  type: constAction.VIAJES_FINDUPD_STATE,
  payload: { id, stateName, data },
});

export const setState = payload => ({
  type: constAction.VIAJES_SET_STATE,
  payload: payload,
});

export const setAndOrderState = payload => ({
  type: constAction.VIAJES_PASAJEROS_ORDER,
  payload: payload,
});

export const set = (data, id, onlyCreate) => {
  let payload = Object.assign({}, data);
  if (id != 'new') payload.viajeId = id;
  return {
    type: constAction.VIAJES_SET,
    onlyCreate,
    payload,
    epic: {
      url: id != 'new' ? 'viajes/editar' : 'viajes',
      method: 'POST',
    },
  };
};

export const delete_ = id => ({
  type: constAction.VIAJES_DELETE,
  epic: {
    url: 'viajes/' + id,
    method: 'DELETE',
  },
});

export const buscar = diaViaje => ({
  type: constAction.VIAJES_BUSCAR,
  payload: {
    diaViaje: moment(diaViaje).format(),
  },
  epic: {
    url: 'viajes/buscar',
    method: 'GET',
  },
});

export const getById = (id, paradas) => ({
  type: constAction.VIAJES_GET_BY_ID,
  payload: { viajeId: id, paradas: paradas ? true : false },
  epic: {
    url: 'viajes/getFull',
    method: 'GET',
  },
});

export const setStateViaje = payload => ({
  type: constAction.VIAJES_SET_STATE_BY_ID,
  payload,
});

export const streamState = result => ({
  type: constAction.VIAJES_STREAM_TO_STATE,
  payload: JSON.parse(result),
});

export const setStateBuscar = payload => ({
  type: constAction.VIAJES_SET_STATE_BUSCAR,
  payload,
});

export const resetDay = day => ({
  type: constAction.VIAJES_RESET_DAY,
  payload: day,
});

export const getPointsTrayecto = viajeId => ({
  type: constAction.VIAJES_GET_TRAYECTOPOINTS,
  payload: { viajeId },
  epic: {
    url: 'viajes/getRecorrido',
    method: 'GET',
  },
});

//--- METODOS DE OTROS COMPONENTES ---//
/**
 * Trae la lista de paradas .
 * @returns {Object}
 */
export const getParadas = () => ({
  type: constAction.VIAJES_PARADAS_GET,
  payload: {
    filter: {
      where: {
        eliminada: false,
      },
    },
  },
  epic: {
    url: 'paradas',
    method: 'GET',
  },
});

export const getPasajeros = viajeId => ({
  type: constAction.VIAJES_PASAJEROS_GET,
  payload: {
    viajeId,
    cancelados: false,
  },
  epic: {
    url: 'reservas/pasajeros',
    method: 'GET',
  },
});

export const getTrayecto = viajeId => ({
  type: constAction.VIAJES_GET_TRAYECTO,
  payload: { viajeId },
  epic: {
    url: 'viajes/getTrayecto',
    method: 'GET',
  },
});

export const setTrayecto = result => ({
  type: constAction.VIAJES_SET_TRAYECTO,
  payload: result,
});

export const setGrupo = (grupoId, agregar) => ({
  type: constAction.VIAJES_SET_GRUPOS,
  payload: { grupoId, agregar },
});



// WEBPACK FOOTER //
// src/modules/viajes/action.js